/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ index: NonNullable<unknown> }} Dialogue_List_Export_Event_Missing_TextInputs */

const en_dialogue_list_export_event_missing_text = /** @type {(inputs: Dialogue_List_Export_Event_Missing_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Event ${i?.index} has no text.
 Would you like to ABORT your export?`)
};

const fr_dialogue_list_export_event_missing_text = /** @type {(inputs: Dialogue_List_Export_Event_Missing_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`L'événement ${i?.index} n'a pas de texte.
 Souhaitez-vous ABANDONNER l'exportation ?`)
};

const de_dialogue_list_export_event_missing_text = /** @type {(inputs: Dialogue_List_Export_Event_Missing_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Das Ereignis ${i?.index} enthält keinen Text.
Möchten Sie den Export abbrechen?`)
};

const it_dialogue_list_export_event_missing_text = /** @type {(inputs: Dialogue_List_Export_Event_Missing_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`L'evento ${i?.index} non contiene testo.
Vuoi ANNULLARE l'esportazione?`)
};

const ru_dialogue_list_export_event_missing_text = /** @type {(inputs: Dialogue_List_Export_Event_Missing_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Событие ${i?.index} не содержит текста.
Вы хотите ОТМЕНИТЬ экспорт?`)
};

const es_dialogue_list_export_event_missing_text = /** @type {(inputs: Dialogue_List_Export_Event_Missing_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`El evento ${i?.index} no tiene texto.
¿Desea cancelar la exportación?`)
};

const zh_cn2_dialogue_list_export_event_missing_text = /** @type {(inputs: Dialogue_List_Export_Event_Missing_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`事件 ${i?.index} 没有文本。

是否要中止导出？`)
};

const ja_dialogue_list_export_event_missing_text = /** @type {(inputs: Dialogue_List_Export_Event_Missing_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`イベント ${i?.index} にテキストがありません。
エクスポートを中止しますか?`)
};

const hi_dialogue_list_export_event_missing_text = /** @type {(inputs: Dialogue_List_Export_Event_Missing_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`इवेंट ${i?.index} में कोई टेक्स्ट नहीं है।
क्या आप अपना निर्यात रद्द करना चाहेंगे?`)
};

const pt_pt2_dialogue_list_export_event_missing_text = /** @type {(inputs: Dialogue_List_Export_Event_Missing_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`O evento ${i?.index} não possui texto.
Deseja CANCELAR a exportação?`)
};

/**
* | output |
* | --- |
* | "Event {index} has no text. Would you like to ABORT your export?" |
*
* @param {Dialogue_List_Export_Event_Missing_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const dialogue_list_export_event_missing_text = /** @type {((inputs: Dialogue_List_Export_Event_Missing_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialogue_List_Export_Event_Missing_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_dialogue_list_export_event_missing_text(inputs)
	if (locale === "de") return de_dialogue_list_export_event_missing_text(inputs)
	if (locale === "it") return it_dialogue_list_export_event_missing_text(inputs)
	if (locale === "ru") return ru_dialogue_list_export_event_missing_text(inputs)
	if (locale === "es") return es_dialogue_list_export_event_missing_text(inputs)
	if (locale === "zh-CN") return zh_cn2_dialogue_list_export_event_missing_text(inputs)
	if (locale === "ja") return ja_dialogue_list_export_event_missing_text(inputs)
	if (locale === "hi") return hi_dialogue_list_export_event_missing_text(inputs)
	if (locale === "pt-PT") return pt_pt2_dialogue_list_export_event_missing_text(inputs)
	return en_dialogue_list_export_event_missing_text(inputs)
});